import React, { useCallback } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import AddItem from '@wix/da-shared-react/pkg/AddItem';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { MAX_TIERS_COUNT } from '../constants';
import s from './AddTierCard.scss';

export type Props = {
  className?: string;
  count: number;
};
export const AddTierCard: React.FC<Props> = ({ className, count }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const createTier = useCallback(
    () =>
      dispatch(
        pushModal(ModalType.TIER_EDIT, {
          wrapInModal: false,
        })
      ),
    [dispatch]
  );

  return (
    <>
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classnames(className, s['root'])}
        onClick={createTier}
      >
        <AddItem
          className={s['add-item']}
          title={t('widgets.tiers.addItem.title')}
          subtitle={t('widgets.tiers.addItem.subtitle', {
            count,
            total: MAX_TIERS_COUNT,
          })}
          onClick={createTier}
        />
      </Flex>
    </>
  );
};

AddTierCard.displayName = 'AddTierCard';
export default AddTierCard;
